import React from 'react';
import { GameSession, GameType } from '../types';

interface GameResultsProps {
  session: GameSession;
  onPlayAgain: () => void;
  onNewGame: (gameType: GameType, cheatMode?: boolean) => void;
}

const gameTypeLabels: Record<GameType, string> = {
  [GameType.NAME_MATCH]: '日英名称マッチング',
  [GameType.INNERVATION]: '神経支配',
  [GameType.BLOOD_SUPPLY]: '血液供給',
  [GameType.INNERVATION_OR_BLOOD]: '神経支配・血液供給',
  [GameType.ORIGIN_INSERTION]: '起始・停止'
};

export const GameResults: React.FC<GameResultsProps> = ({
  session,
  onPlayAgain,
  onNewGame
}) => {
  const gameTime = session.endTime! - session.startTime;
  const minutes = Math.floor(gameTime / 60000);
  const seconds = Math.floor((gameTime % 60000) / 1000);
  
  const scorePercentage = Math.round((session.score / session.questions.length) * 100);
  
  const getScoreMessage = (percentage: number) => {
    if (percentage >= 90) return '素晴らしい！';
    if (percentage >= 80) return 'とても良い！';
    if (percentage >= 70) return '良い！';
    if (percentage >= 60) return 'もう少し！';
    return '頑張って！';
  };
  
  return (
    <div className="game-results">
      <div className="results-header">
        <h2>ゲーム結果</h2>
        <div className="game-labels">
          <div className="game-type-label">
            {gameTypeLabels[session.type]}
          </div>
          <div className={`mode-label ${session.cheatMode ? 'cheat' : 'serious'}`}>
            {session.cheatMode ? 'チートモード' : '本気モード'}
          </div>
        </div>
      </div>
      
      <div className="results-stats">
        <div className="stat-item">
          <div className="stat-value">{session.score}/{session.questions.length}</div>
          <div className="stat-label">正解数</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-value">{scorePercentage}%</div>
          <div className="stat-label">正解率</div>
        </div>
        
        <div className="stat-item">
          <div className="stat-value">{minutes}:{seconds.toString().padStart(2, '0')}</div>
          <div className="stat-label">所要時間</div>
        </div>
      </div>
      
      <div className="score-message">
        {getScoreMessage(scorePercentage)}
      </div>
      
      <div className="results-actions">
        <button className="play-again-button" onClick={onPlayAgain}>
          同じゲーム・モードをもう一度
        </button>
        
        <div className="new-game-options">
          <h3>別のゲームタイプを選択</h3>
          <div className="game-type-buttons">
            {Object.entries(gameTypeLabels)
              .filter(([type]) => type !== session.type)
              .map(([type, label]) => (
                <button
                  key={type}
                  className="new-game-button"
                  onClick={() => onNewGame(type as GameType, session.cheatMode)}
                >
                  {label}
                </button>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};